/* RGG2 sliders, tabs and videos. Re-inits on theme editor events. */
(function(){
  if (window.RGG2) { return; }
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function kids(el, cls){ return Array.prototype.filter.call(el.children, function(c){ return c.classList.contains(cls); })[0] || null; }
  function Car(el){
    this.el = el; this.track = kids(el, 'rgg2-car__track');
    this.items = Array.prototype.slice.call(this.track.children);
    this.fade = el.getAttribute('data-effect') === 'fade';
    this.auto = (parseFloat(el.getAttribute('data-autoplay')) || 0) * 1000;
    this.loop = el.getAttribute('data-loop') !== 'false';
    this.pauseHover = el.getAttribute('data-pause') !== 'false';
    this.dots = kids(el, 'rgg2-car__dots'); this.prev = kids(el, 'rgg2-car__prev'); this.next = kids(el, 'rgg2-car__next');
    this.i = 0; this.hover = false; this.visible = true; this.timer = null;
    this.init();
  }
  Car.prototype.step = function(){
    if (this.items.length > 1) { return this.items[1].offsetLeft - this.items[0].offsetLeft; }
    return this.track.clientWidth;
  };
  Car.prototype.pages = function(){
    if (this.fade) { return this.items.length; }
    var st = this.step(); if (!st) { return 1; }
    return Math.max(1, Math.round((this.track.scrollWidth - this.track.clientWidth) / st) + 1);
  };
  Car.prototype.go = function(i, smooth){
    var n = this.pages();
    if (i < 0) { i = this.loop ? n - 1 : 0; }
    if (i >= n) { i = this.loop ? 0 : n - 1; }
    this.i = i;
    if (this.fade) { this.sync(); }
    else { this.track.scrollTo({ left: i * this.step(), behavior: smooth === false ? 'auto' : 'smooth' }); }
  };
  Car.prototype.sync = function(){
    var self = this, n = this.pages();
    if (!this.fade) { var st = this.step(); this.i = st ? Math.round(this.track.scrollLeft / st) : 0; }
    if (this.fade) { this.items.forEach(function(s, k){ s.classList.toggle('is-active', k === self.i); }); }
    else {
      var pv = Math.max(1, Math.round(this.track.clientWidth / (this.step() || 1)));
      this.items.forEach(function(s, k){ s.classList.toggle('is-active', k >= self.i && k < self.i + pv); });
    }
    if (this.dots) {
      if (this.dots.children.length !== n) { this.buildDots(n); }
      Array.prototype.forEach.call(this.dots.children, function(d, k){ d.classList.toggle('is-active', k === self.i); });
    }
    if (this.prev && this.next && !this.loop) { this.prev.disabled = this.i <= 0; this.next.disabled = this.i >= n - 1; }
    this.el.classList.toggle('is-static', n <= 1);
    this.media();
  };
  Car.prototype.buildDots = function(n){
    var self = this; this.dots.innerHTML = '';
    for (var k = 0; k < n; k++) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (k + 1));
      (function(k){ b.addEventListener('click', function(){ self.go(k); self.restart(); }); })(k);
      this.dots.appendChild(b);
    }
  };
  Car.prototype.media = function(){
    if (!this.fade) { return; }
    var self = this;
    this.items.forEach(function(s, k){
      s.querySelectorAll('video').forEach(function(v){ if (k === self.i) { var p = v.play(); if (p && p.catch) { p.catch(function(){}); } } else { v.pause(); } });
    });
  };
  Car.prototype.restart = function(){
    var self = this; clearInterval(this.timer);
    if (!this.auto || RM || this.pages() <= 1) { return; }
    this.timer = setInterval(function(){ if (!self.hover && self.visible && !document.hidden) { self.go(self.i + 1); } }, this.auto);
  };
  Car.prototype.init = function(){
    var self = this, raf = null;
    if (this.prev) { this.prev.addEventListener('click', function(){ self.go(self.i - 1); self.restart(); }); }
    if (this.next) { this.next.addEventListener('click', function(){ self.go(self.i + 1); self.restart(); }); }
    if (!this.fade) {
      this.track.addEventListener('scroll', function(){ if (raf) { return; } raf = requestAnimationFrame(function(){ raf = null; self.sync(); }); }, { passive: true });
    }
    if (this.fade) {
      var x0 = null;
      this.track.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      this.track.addEventListener('touchend', function(e){ if (x0 === null) { return; } var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { self.go(self.i + (dx < 0 ? 1 : -1)); self.restart(); } x0 = null; }, { passive: true });
    }
    if (this.pauseHover) {
      this.el.addEventListener('mouseenter', function(){ self.hover = true; });
      this.el.addEventListener('mouseleave', function(){ self.hover = false; });
    }
    this.track.addEventListener('touchstart', function(){ self.restart(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){ self.visible = es[0].isIntersecting; }, { threshold: .2 }).observe(this.el);
    }
    window.addEventListener('resize', function(){ self.sync(); });
    this.sync(); this.restart();
    requestAnimationFrame(function(){ self.el.classList.add('is-ready'); });
  };
  function initVids(root){
    root.querySelectorAll('[data-rgg2-vid]').forEach(function(w){
      if (w._rgg2) { return; } var v = w.querySelector('video'); if (!v) { return; } w._rgg2 = 1;
      var mode = w.getAttribute('data-mode') || 'inview';
      if (!v.getAttribute('src') && v.getAttribute('data-src-d')) { var mob = window.matchMedia('(max-width: 749px)').matches; v.addEventListener('error', function(){ var f = v.getAttribute('data-src-f'); if (f && v.getAttribute('src') !== f) { v.src = f; } }, { once: true }); v.src = v.getAttribute(mob ? 'data-src-m' : 'data-src-d'); }
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = w.getAttribute('data-loop') !== 'false';
      function play(){ var p = v.play(); if (p && p.catch) { p.catch(function(){}); } w.classList.add('is-playing'); }
      function pause(){ v.pause(); w.classList.remove('is-playing'); }
      var touch = window.matchMedia('(hover: none)').matches;
      if (mode === 'inview' || (mode === 'hover' && touch)) {
        if ('IntersectionObserver' in window) { new IntersectionObserver(function(es){ if (es[0].isIntersecting) { play(); } else { pause(); } }, { threshold: .35 }).observe(w); } else { play(); }
      } else if (mode === 'hover') {
        w.addEventListener('mouseenter', play); w.addEventListener('mouseleave', pause);
      }
      var btn = w.querySelector('.rgg2-vid__play');
      if (btn) { btn.addEventListener('click', function(e){ e.preventDefault(); if (w.getAttribute('data-sound') === 'true') { v.muted = false; } if (v.paused) { play(); } else { pause(); } }); }
      if (mode === 'click') { v.addEventListener('click', function(){ if (!v.paused) { pause(); } }); }
      var m = w.querySelector('.rgg2-vid__mute');
      if (m) { m.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; m.classList.toggle('is-on', !v.muted); if (v.paused) { play(); } }); }
    });
  }
  function initTabs(root){
    root.querySelectorAll('[data-rgg2-tabs]').forEach(function(t){
      if (t._rgg2) { return; } t._rgg2 = 1;
      var sec = t.closest('.rgg2');
      t.querySelectorAll('.rgg2-tab').forEach(function(b){
        b.addEventListener('click', function(){
          var id = b.getAttribute('data-tab');
          t.querySelectorAll('.rgg2-tab').forEach(function(x){ x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b); });
          sec.querySelectorAll('.rgg2-panel').forEach(function(p){ var on = p.getAttribute('data-panel') === id; p.hidden = !on; if (on) { p.querySelectorAll('[data-rgg2-car]').forEach(function(c){ if (c._car) { c._car.sync(); } }); } });
        });
      });
    });
  }
  function init(root){
    root = root || document;
    root.querySelectorAll('[data-rgg2-car]').forEach(function(el){ if (!el._car) { el._car = new Car(el); } });
    initVids(root); initTabs(root);
  }
  window.RGG2 = { init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var it = e.target.closest('.rgg2-car__item'); var c = e.target.closest('[data-rgg2-car]');
    if (it && c && c._car) { clearInterval(c._car.timer); var k = c._car.items.indexOf(it); if (c._car.fade) { c._car.go(k); } else { c._car.track.scrollTo({ left: it.offsetLeft - c._car.items[0].offsetLeft, behavior: 'smooth' }); } }
    var tab = e.target.closest('.rgg2-tab'); if (tab) { tab.click(); }
  });
  document.addEventListener('shopify:block:deselect', function(e){ var c = e.target.closest('[data-rgg2-car]'); if (c && c._car) { c._car.restart(); } });
})();